import {
  ApiBlueprint,
  PageBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
  oktaAuthApiRef,
} from '@backstage/frontend-plugin-api';
import AccountTree from '@material-ui/icons/AccountTree';

import { compositeDetailsRouteRef, rootRouteRef } from './routes';
import { CompositeClient, compositeApiRef } from './api/CompositeClient';

const compositeApi = ApiBlueprint.make({
  name: 'composite-api',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: compositeApiRef,
        deps: {
          discoveryApi: discoveryApiRef,
          fetchApi: fetchApiRef,
          oktaAuthApi: oktaAuthApiRef,
        },
        factory: ({ discoveryApi, fetchApi, oktaAuthApi }) =>
          new CompositeClient({ discoveryApi, fetchApi, oktaAuthApi }),
      }),
    ),
});

const listPage = PageBlueprint.make({
  params: {
    title: 'Composites',
    icon: <AccountTree fontSize="inherit" />,
    path: '/composites',
    routeRef: rootRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/CompositesListPage/CompositesListPage').then(m => (
        <m.CompositesListPage />
      )),
  },
});

const detailPage = PageBlueprint.make({
  name: 'detail',
  params: {
    path: '/composites/:compositeId',
    routeRef: compositeDetailsRouteRef,
    noHeader: true,
    loader: () =>
      import('./components/CompositeDetailsPage/CompositeDetailsPage').then(
        m => <m.CompositeDetailsPage />,
      ),
  },
});

export default createFrontendPlugin({
  info: {
    packageJson: () => import('../package.json'),
    manifest: () => import('../catalog-info.yaml'),
  },
  pluginId: 'neo4j-composite',
  extensions: [compositeApi, listPage, detailPage],
  routes: {
    root: rootRouteRef,
    compositeDetails: compositeDetailsRouteRef,
  },
});
